import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAssortmentTree } from "src/models/Products/AssortmentTree.models";
import { IAssortmentTreeView } from "../../../models/Products/AssortmentTreeView.models";

interface AssortmentTreeState {
  assortmentTrees: IAssortmentTree[];
  assortmentTreeToEdit: IAssortmentTree | null;
  assortmentTreesView: IAssortmentTreeView[];
}

const initialState: AssortmentTreeState = {
  assortmentTrees: [],
  assortmentTreeToEdit: null,
  assortmentTreesView: [],
};

const assortmentTreeSlice = createSlice({
  name: "AssortmentTree",
  initialState,
  reducers: {
    setAssortmentTreeList: (
      state,
      action: PayloadAction<IAssortmentTree[]>
    ) => {
      state.assortmentTrees = action.payload;
    },
    concatListAssortmentTree: (
      state: AssortmentTreeState,
      action: PayloadAction<IAssortmentTree[]>
    ) => {
      state.assortmentTrees = [...state.assortmentTrees.concat(action.payload)];
    },
    setAssortmentTreeToEdit: (
      state,
      action: PayloadAction<IAssortmentTree | null>
    ) => {
      state.assortmentTreeToEdit = action.payload;
    },
    updateAssortmentTree: (state, action: PayloadAction<IAssortmentTree>) => {
      let itemIndex = state.assortmentTrees.findIndex(
        item => item.assortmentTreeId === action.payload.assortmentTreeId
      );
      if (itemIndex !== -1) state.assortmentTrees[itemIndex] = action.payload;
    },
    setAssortmentTreeViewList: (
      state,
      action: PayloadAction<IAssortmentTreeView[]>
    ) => {
      state.assortmentTreesView = action.payload;
    },
    concatListAssortmentViewTree: (
      state: AssortmentTreeState,
      action: PayloadAction<IAssortmentTreeView[]>
    ) => {
      state.assortmentTreesView = [
        ...state.assortmentTreesView.concat(action.payload),
      ];
    },
  },
});

export const {
  setAssortmentTreeList,
  concatListAssortmentTree,
  setAssortmentTreeToEdit,
  updateAssortmentTree,
  setAssortmentTreeViewList,
  concatListAssortmentViewTree,
} = assortmentTreeSlice.actions;

export default assortmentTreeSlice.reducer;
